import React from 'react';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './notification.css';
import CloseIcon from '../svg/close';
import { nombreEleccion } from '../../resources/constantes.json';
import styled from 'styled-components/macro';
import {
  getNotificationText,
  useDispatchNotifications,
  actionTypes,
} from '../../contexts/notificationsContext';
import { useTranslate } from '../../contexts/languageContext';
import { getUrl } from '../../utils';
import { Link } from 'react-router-dom';
/**
 * Notificacion que se muestra en pantalla cuando se recibe una notificación mediante
 * el archivo json de indicador de notificaciones. Presenta información sobre la elección
 * a la que corresponde la notificacion y un botón para ir a esa elección
 */

const NotificationContainer = props => {
  return (
    <StyledToastContainer
      transition={Zoom}
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={true}
      closeOnClick={true}
      draggable
      pauseOnHover
      className="notification"
      bodyClassName="notification--body"
      progressClassName="notification--progres-bar"
      closeButton={<CloseButton />}
    />
  );
};
export const BodyNotificacion = ({ notification, nomenclator }) => {
  const { eleccion, mdhm } = notification;
  const t = useTranslate();
  const dispatch = useDispatchNotifications();
  const { title, subtitle } = getNotificationText({
    eleccion,
    tope: 0,
    mdhm,
    t,
  });
  return (
    <StyledBoxLink
      css="display:block"
      to={getUrl({
        id: 0,
        eleccion,
        nomenclator,
        page: nombreEleccion[eleccion],
      })}
      onClick={() => dispatch({ type: actionTypes.read, id: notification.id })}
    >
      <Texto>
        <div className="title"> {title}</div>
        <div className="subtitle"> {subtitle}</div>
      </Texto>
      <Center>
        <StyledLink
          to={getUrl({
            id: 0,
            eleccion,
            nomenclator,
            page: nombreEleccion[eleccion],
          })}
        >
          {t('aceptar')}
        </StyledLink>
      </Center>
    </StyledBoxLink>
  );
};

const StyledToastContainer = styled(ToastContainer)`
@media print {
  display:none;
  }
`;

const StyledBoxLink = styled(Link)`
  border: 1px solid #1C283D;
  border-raidus: 3px;
  padding: 10px;
  &&:hover {
    text-decoration: none;
  }
  @media print {
    display:none;
    }
`;

const Center = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const StyledLink = styled(Link)`
  background-color: #00F7F0;
  font-size: 16px;
  color: #1C4183;
  padding: 5px 30px;
  text-transform: uppercase;
  font-weight: bold;
  font-family: 'Raleway', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica',
    'sans-serif';
`;

const CloseButton = ({ closeToast }) => {
  return (
    <SCloseIcon
      width="23px"
      height="23px"
      fill="#283f5f"
      onClick={closeToast}
    />
  );
};

const SCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 10px;
  top: 10px;
`;

const Texto = styled.div`
  display: block;
  padding: 10px;
  @media (max-width: 768px) {
    padding: 10px 20px 10px 10px;
  }
  .title {
    font-size: 14px;
    line-height: 2;
    color: #283F5F;
    font-family: 'Raleway', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica',
      'sans-serif';
  }

  .subtitle {
    color: #222;
    line-height: 2;
    padding: 0;
    font-size: 12px;
    font-family: 'Raleway', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica',
      'sans-serif';
  }
`;

export default NotificationContainer;
